import { cn } from "./cn";

interface FormFieldProps {
  label: string;
  error?: string;
  children?: React.ReactNode;
  addButton?: React.ReactNode;
  className?: string;
  required?: boolean;
}

export const FormField = ({
  label,
  error,
  children,
  addButton,
  className,
  required, // 🆕
}: FormFieldProps) => (
  <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
    <label
      className={cn("font-bold text-blue-light text-md italic", className)}
    >
      <div className="flex">
        {required && <span className="ml-0.5 text-red-500">*</span>} {/* 🆕 */}
        {label}
        <div className="translate-y-[-3px]">{addButton}</div>
      </div>
    </label>
    {children}
    {error && <span className="text-red-400 text-xs">{error}</span>}
  </div>
);
